module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "admin-filter"
    }
  }, [_c('h4', [_vm._v("Role filter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "role-code"
    }
  }, [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.code),
      expression: "entity.code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "role-code"
    },
    domProps: {
      "value": (_vm.entity.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "role-desc"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "role-desc"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.emitSearch
    }
  }, [_vm._v("\n      Search\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3181a393"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Role/RoleFilter.vue
// module id = 2136
// module chunks = 1